import { lazy } from "react";
import routes from "./routesConfig/index";

const Agencies = lazy(() => import("../SettingsPage/agencies/Agencies"));
const Settings = lazy(() => import("../SettingsPage/Settings"));
const AddAgency = lazy(() => import("../SettingsPage/agencies/add-agency/AddAgency"));
const Branches = lazy(() => import("../SettingsPage/branches/Branches"));
const Roles = lazy(() => import("../SettingsPage/roles/Roles"));
const AddBranch = lazy(() => import("../SettingsPage/branches/AddBranch"));
const AddRole = lazy(() => import("../SettingsPage/roles/AddRole"));
const Users = lazy(() => import("../SettingsPage/users/Users"));
const AddUser = lazy(() => import("../SettingsPage/users/add-user/AddUser"));
const Leaves = lazy(() => import("../SettingsPage/leaves/Leaves"));
const ApplyLeave = lazy(() => import("../SettingsPage/leaves/ApplyLeave"));
const DaysOfOperation = lazy(() => import("../SettingsPage/days-of-operation/DaysOfOperation"));
const AddDaysOfOpertaion = lazy(() => import("../SettingsPage/days-of-operation/AddDaysOfOpertaion"));
const HolidayList = lazy(() => import("../SettingsPage/holiday-list/HolidayList"));
const TemplateList = lazy(() => import("../SettingsPage/templates/TemplateList"));
const AddHoliday = lazy(() => import("../SettingsPage/holiday-list/AddHolidayList"));
const AddTemplate = lazy(() => import("../SettingsPage/templates/AddTemplateList"));
const ShiftCodes = lazy(() => import("../SettingsPage/shift-codes/ShiftCodeList"));
const AddShiftCode = lazy(() => import("../SettingsPage/shift-codes/AddShiftCode"));
const ImportShiftRoster = lazy(() => import("../SettingsPage/shift-codes/ImportShiftRoaster"));
const LeavePolicy = lazy(() => import("../SettingsPage/leave-policy/LeavePolicy"));
const AddLeavePolicy = lazy(() => import("../SettingsPage/leave-policy/add-leave-policy/AddLeavePolicy"));
const ManualUpdateLeaves = lazy(() => import("../SettingsPage/manual-update-leaves/ManualUpdateLeaves"));
const ViewLeaveLedger = lazy(() => import("../SettingsPage/view-leave-ledger/ViewLeaveLedger"));
const PriceList = lazy(() => import("../SettingsPage/price-list/PriceList"));
const MedicalList = lazy(() => import("../SettingsPage/medical/MedicalList"));
const AddMedicalClinic = lazy(() => import("../SettingsPage/medical/AddMedicalList"));
const PromptManager = lazy(() => import("../SettingsPage/prompt-manager/PromptManager"));
const NewPromptTemplate = lazy(() => import("../SettingsPage/prompt-manager/NewPromptTemplate"));

const settingsRoutes = [
  { path: routes.settings, component: Settings, moduleKey: "settings", permissionKey: "settings_access"},
  { path: routes.agencies, component: Agencies, moduleKey:"settings", permissionKey: "view_agency" },
  { path: routes.addAgency, component: AddAgency, moduleKey:"settings", permissionKey: 'edit_agency' },
  { path: routes.branches, component: Branches, moduleKey:"settings", permissionKey: "view_branch" },
  { path: routes.addBranch, component: AddBranch, moduleKey:"settings", permissionKey: 'edit_branch' },
  { path: routes.roles, component: Roles, moduleKey:"users", permissionKey: "view_role" },
  { path: routes.addRole, component: AddRole, moduleKey:"users", permissionKey: "edit_role" },
  { path: routes.users, component: Users, moduleKey:"users", permissionKey: "users_access" },
  { path: routes.addUser, component: AddUser, moduleKey:"users", permissionKey: "edit_user" },
  { path: routes.leaves, component: Leaves },
  { path: routes.applyLeave, component: ApplyLeave },
  { path: routes.daysOfOperation, component: DaysOfOperation, moduleKey:"configuration", permissionKey: "view_doop" },
  { path: routes.addDaysOfOperation, component: AddDaysOfOpertaion, moduleKey:"configuration", permissionKey: "edit_doop" },
  { path: routes.holidays, component: HolidayList, moduleKey:"configuration", permissionKey: "view_holiday" },
  { path: routes.addHoliday, component: AddHoliday, moduleKey:"configuration", permissionKey: "edit_holiday"   },
  { path: routes.templates, component: TemplateList },
  { path: routes.addTemplate, component: AddTemplate },
  { path: routes.shiftCodes, component: ShiftCodes, moduleKey:"configuration", permissionKey: "view_shift_code" },
  { path: routes.addShiftCode, component: AddShiftCode, moduleKey:"configuration", permissionKey: "edit_shift_code" },
  { path: routes.importShiftRoster, component: ImportShiftRoster, moduleKey:"configuration", permissionKey: "import_shift_code" },
  { path: routes.leavePolicy, component: LeavePolicy, moduleKey:"configuration", permissionKey: "view_leave_policy" },
  { path: routes.addLeavePolicy, component: AddLeavePolicy, moduleKey:"configuration", permissionKey: "edit_leave_policy" },
  { path: routes.manualUpdateLeaves, component: ManualUpdateLeaves, moduleKey:"hrms", permissionKey: "manual_update_leave" },
  { path: routes.viewLeaveLedger, component: ViewLeaveLedger, moduleKey:"hrms", permissionKey: "view_leave_ledger"},
  { path: routes.priceList, component: PriceList },
  { path: routes.medicalList, component: MedicalList },
  { path: routes.addMedicalClinic, component: AddMedicalClinic },
  { path: routes.promptManager, component: PromptManager },
  { path: routes.newPromptTemplate, component: NewPromptTemplate },
];

export default settingsRoutes;